import { useEffect } from "react";
import { formatCPFCNPJ, formatTelefone } from "../../../../util/formats";
import { useAppSelector } from "../../../../util/hooks";
import { EmpresaState } from "../../../../redux/slices/empresa/empresaSlice";

const VisualizarEmpresa = () => {
  //estados globais
  const empresaState = useAppSelector((state) => state.empresa);

  useEffect(() => {}, [empresaState.entity]);

  return (
    <>
      <p>Razão Social: {empresaState.entity.razaoSocial ? empresaState.entity.razaoSocial : "-"}</p>
      <p>Nome Fantasia: {empresaState.entity.apelido ? empresaState.entity.apelido : "-"}</p>
      <p>Tipo Pessoa: {empresaState.entity.tipoPessoa ? empresaState.entity.tipoPessoa : "-"}</p>
      <p>CPF/CNPJ: {empresaState.entity.cpfcnpj ? formatCPFCNPJ(empresaState.entity.cpfcnpj) : "-"}</p>
      <p>Inscricao Estadual: {empresaState.entity.inscricaoEstadual ? empresaState.entity.inscricaoEstadual : "-"}</p>
      <p>Inscricao Municipal: {empresaState.entity.inscricaoMunicipal ? empresaState.entity.inscricaoMunicipal : "-"}</p>
      <p>CEP: {empresaState.entity.cep ? empresaState.entity.cep : "-"}</p>
      <p>Endereço: {empresaState.entity.endereco ? empresaState.entity.endereco : "-"}</p>
      <p>Número: {empresaState.entity.numero ? empresaState.entity.numero : "-"}</p>
      <p>Complemento: {empresaState.entity.complemento ? empresaState.entity.complemento : "-"}</p>
      <p>Bairro: {empresaState.entity.bairro ? empresaState.entity.bairro : "-"}</p>
      <p>Cidade: {empresaState.entity.cidade ? empresaState.entity.cidade : "-"}</p>
      <p>Site: {empresaState.entity.homepage ? empresaState.entity.homepage : "-"}</p>
      <p>E-mail: {empresaState.entity.email ? empresaState.entity.email : "-"}</p>
      <p>Ativo: {empresaState.entity.ativo ? "SIM" : "NÃO"}</p>
      <p>Nome Contato: {empresaState.entity.nomeContato ? empresaState.entity.nomeContato : "-"}</p>
      <p>Email Contato: {empresaState.entity.emailContato ? empresaState.entity.emailContato : "-"}</p>
      <p>Telefone Contato: {empresaState.entity.telefoneContato ? formatTelefone(empresaState.entity.telefoneContato) : "-"}</p>
    </>
  );
};

export default VisualizarEmpresa;
